<template>
    <div class="vx-col md:w-full sm:w-auto">
        <div class="vx-row md:w-full">
            <vx-tooltip class="position-icon" :text="$t('button.details')" position="top">
                <feather-icon icon="EyeIcon" class="action-success icon-btn mt-3"
                    svg-classes="h-5 w-5 hover:text-primary cursor-pointer" @click="updateHistoryExam">
                </feather-icon>
            </vx-tooltip>
        </div>
        <vs-popup class="holamundo" title="Giao bài tập" :active.sync="openAssignAssignments"
            v-if="openAssignAssignments" id="asgm">
            <assignmentsInformation :quizIdHistory="params.data.id"></assignmentsInformation>
        </vs-popup>
    </div>
</template>
<script>
import assignmentsInformation from "../AssignAssignmentsInformation.vue";
export default {
    name: 'CellRendererHistoryExam',
    components: {
        assignmentsInformation
    },
    data() {
        return {
            openAssignAssignments: false,
        }
    },
    methods:{
        updateHistoryExam(){
            this.openAssignAssignments = true;
        },
    },
    watch: {
        '$store.state.isUpdateQuestion'(val) {
            if (val) {
                this.openAssignAssignments = false;
                this.$store.commit('UPDATE_QUESTION', false);
            }
        }
    },
}
</script>
<style lang="scss">
#asgm {
    .vs-popup {
        width: 1400px !important;
    }
}
</style>
